import React from 'react';
import {
  RadioGroupContainer,
  RadioButtonLabel,
  RadioButtonInput,
  RadioButtonIndicatorWrapper,
  RadioButtonIndicator,
} from './styles';
import { BaseText } from 'styles/__typography';

type Option = {
  value: string;
  label: string;
};

type RadioGroupProps = {
  title: string;
  options: Option[];
  onChange: (value: string) => void;
  onBlur: () => void;
  value: string;
};

export const RadioGroup = ({ title, options, onBlur, onChange, value }: RadioGroupProps) => (
  <>
    <BaseText fontFamily="Inter" fontSize={1} fontWeight={2} mb={4}>
      {title}
    </BaseText>
    <RadioGroupContainer>
      {options.map(option => (
        <RadioButtonLabel key={option.value} checked={value === option.value}>
          <RadioButtonInput
            type="radio"
            name="radioGroup"
            value={option.value}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            checked={value === option.value}
          />
          <BaseText fontFamily="Inter" fontWeight={1} color="text.primary">
            {option.label}
          </BaseText>
          <RadioButtonIndicatorWrapper checked={value === option.value}>
            <RadioButtonIndicator checked={value === option.value} />
          </RadioButtonIndicatorWrapper>
        </RadioButtonLabel>
      ))}
    </RadioGroupContainer>
  </>
);
